// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2SQ_k","legacyBtn":"MutateMid_legacyBtn__2RMru"};